/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments';
import type { FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO } from './FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Login: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLogin;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Store: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Inapp?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInapp | null;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    PushTokens: FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTO;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Hub: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHub;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    Documents: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocuments;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures
     */
    PromoCode: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    if (!('Login' in value) || value['Login'] === undefined) return false;
    if (!('Store' in value) || value['Store'] === undefined) return false;
    if (!('PushTokens' in value) || value['PushTokens'] === undefined) return false;
    if (!('Hub' in value) || value['Hub'] === undefined) return false;
    if (!('Documents' in value) || value['Documents'] === undefined) return false;
    if (!('PromoCode' in value) || value['PromoCode'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    if (json == null) {
        return json;
    }
    return {
        
        'Login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginFromJSON(json['login']),
        'Store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON(json['store']),
        'Inapp': json['inapp'] == null ? undefined : FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappFromJSON(json['inapp']),
        'PushTokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOFromJSON(json['push_tokens']),
        'Hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubFromJSON(json['hub']),
        'Documents': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsFromJSON(json['documents']),
        'PromoCode': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON(json['promo_code']),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatures | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'login': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureLoginToJSON(value['Login']),
        'store': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON(value['Store']),
        'inapp': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturesInappToJSON(value['Inapp']),
        'push_tokens': FxIdApplicationHandlersNativeStatusNativeStatusPushTokenDTOToJSON(value['PushTokens']),
        'hub': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureHubToJSON(value['Hub']),
        'documents': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentsToJSON(value['Documents']),
        'promo_code': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON(value['PromoCode']),
    };
}

